import { render } from "./EditUsers.vue?vue&type=template&id=63a90138&scoped=true"
import script from "./EditUsers.vue?vue&type=script&lang=js"
export * from "./EditUsers.vue?vue&type=script&lang=js"

import "./EditUsers.vue?vue&type=style&index=0&id=63a90138&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a90138"]])

export default __exports__